<div class="titles-wrapper">
  <div class="title-container">
    <span class="item-txt">Botón del menu:</span>
    <input
      class="colorpicker-input"
      [(ngModel)]="tool.integration.template.btn"
      [value]="tool.integration.template.btn"
      [style.background]="tool.integration.template.btn"
      [(colorPicker)]="tool.integration.template.btn" />
  </div>
  <div class="title-container">
    <span class="item-txt">Breadcrumbs:</span>
    <input
      class="colorpicker-input"
      [(ngModel)]="tool.integration.template.breadcrumbs"
      [value]="tool.integration.template.breadcrumbs"
      [style.background]="tool.integration.template.breadcrumbs"
      [(colorPicker)]="tool.integration.template.breadcrumbs" />
  </div>
  <div class="title-container">
    <span class="item-txt">VIP text color:</span>
    <input
      class="colorpicker-input"
      [(ngModel)]="tool.integration.defaultmode.vip"
      [value]="tool.integration.defaultmode.vip"
      [style.background]="tool.integration.defaultmode.vip"
      [(colorPicker)]="tool.integration.defaultmode.vip" />
      <!-- <button class="btn btn-default">Default VIP color</button> -->
      <button class="mx-0 mt-2 btn-action" (click)="tool.integration.defaultmode.vip = '#fe9503'">Default VIP color</button>
  </div>

  <!--
      <div class="title-container">
    <span class="item-txt">Background del menu:</span>
    <input
      class="colorpicker-input"
      [(ngModel)]="tool.integration.template.bg"
      [value]="tool.integration.template.bg"
      [style.background]="tool.integration.template.bg"
      [(colorPicker)]="tool.integration.template.bg" />
  </div>
  <div class="title-container">
    <span class="item-txt">Texto del menu:</span>
    <input
      class="colorpicker-input"
      [(ngModel)]="tool.integration.template.txt"
      [value]="tool.integration.template.txt"
      [style.background]="tool.integration.template.txt"
      [(colorPicker)]="tool.integration.template.txt" />
  </div>
  <div class="title-container">
    <span class="item-txt">Texto activo del menu:</span>
    <input
      class="colorpicker-input"
      [(ngModel)]="tool.integration.template.txtactive"
      [value]="tool.integration.template.txtactive"
      [style.background]="tool.integration.template.txtactive"
      [(colorPicker)]="tool.integration.template.txtactive" />
  </div>
  -->
</div>
